import { useMutation } from '@tanstack/react-query';
import { updateHouseCriticalInfoHousesHouseIdCriticalInfoPutMutation } from '@/client/@tanstack/react-query.gen.ts';

/**
 * Mutation hook for updating an existing critical info document
 * @param houseId - The ID of the house
 * @returns A mutation object for updating a critical info document
 */
export const useUpdateCriticalInfo = (houseId: number) => {
	return useMutation(
		updateHouseCriticalInfoHousesHouseIdCriticalInfoPutMutation({
			path: { house_id: houseId },
		}),
	);
};
